<template>
  <!-- Small centered column -->
  <b-col offset-lg="3" lg="6" class="spacer-top-big">
    <!-- Form -->
    <b-form>
      <!-- Card -->
      <b-card
        class="card-small"
        header-tag="h3"
        header="Job Detail">
        <!-- Card Body -->
        <b-row class="pb-3">
          <b-col lg='3'><strong>{{ $t("JobDetail.type") }}:</strong></b-col>
          <b-col lg='9'>{{Job.type}}</b-col>
        </b-row>
        <b-row class="pb-3">
          <b-col lg='3'><strong>{{ $t("JobDetail.argument") }}:</strong></b-col>
          <b-col lg='9'>{{Job.argument}}</b-col>
        </b-row>
        <b-row class="pb-3">
          <b-col lg='3'><strong>{{ $t("JobDetail.status") }}:</strong></b-col>
          <b-col lg='9'>{{Job.status}}</b-col>
        </b-row>
        <b-row>
          <b-col lg='3'><strong>{{ $t("JobDetail.result") }}:</strong></b-col>
          <b-col lg='9'>{{Job.result}}</b-col>
        </b-row>
        <!-- Card Body END -->
        <!-- Card Footer -->
        <div
          slot="footer"
          class="text-right">
          <!-- <b-btn data-trackname="jobDetailCancel" @click="cancel" variant="link">
            Cancel
          </b-btn> -->
          <b-btn data-trackname="jobDetailDelete"
            v-if="Job.id"
            @click="delete_item"
            variant="danger" >
            {{ $t("JobDetail.delete_btn") }}
            <i class="fa fa-trash"></i>
          </b-btn>
        </div>
        <!-- Card Footer END -->
      </b-card>
      <!-- Main Card END -->
    </b-form>
    <!-- Form END -->
  </b-col>
  <!-- Small centered column END -->
</template>

<script>
export default {
  name: 'JobDetail',
  i18n: {
    messages: {
      en: {
        JobDetail: {
          type: 'Type',
          argument: 'Argument',
          status: 'Status',
          result: 'Result',
          delete_btn: 'Delete'
        }
      },
      es: {
        JobDetail: {
          type: 'Tipo',
          argument: 'Argumento',
          status: 'Estatus',
          result: 'Resultado',
          delete_btn: 'Borrar'
        }
      }
    }
  },
  data () {
    return {
      Job: {
        id: '',
        type: '',
        argument: '',
        status: '',
        result: ''
      }
    };
  },
  methods: {
    delete_item: function () {
      this.$http.delete('jobs/' + this.Job.id + '/').then(response => {
        if (response.ok) {
          this.$router.push({name: 'Home'});
        }
      });
    },
    cancel: function () {
      this.$router.push({name: 'JobList'});
    }
  },
  mounted: function () {
    window.scrollTo(0, 0);
    this.$http.get('jobs/' + this.$route.params.id).then(response => {
      this.Job = response.data;
    });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/Index/JobDetail.vue